import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const { isLoading } = useAuth();
  const location = useLocation();

  const checkLocalStorage = () => {
    const userStr = localStorage.getItem('user');
    if (!userStr) return { hasAuth: false, user: null };
    try {
      return { hasAuth: true, user: JSON.parse(userStr) };
    } catch {
      return { hasAuth: false, user: null };
    }
  };

  const localAuth = checkLocalStorage();

  // Show loading only briefly while context is loading
  if (isLoading && localAuth.hasAuth) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-emerald-500 mx-auto"></div>
          <p className="mt-4 text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  // No authentication data at all
  if (!localAuth.hasAuth) {
    return <Navigate to="/auth/role-selection" state={{ from: location }} replace />;
  }

  // Check role if required
  if (requiredRole && localAuth.user) {
    const userRole = localAuth.user.role?.name || localAuth.user.role_name;
    if (userRole !== requiredRole) {
      return <Navigate to="/auth/role-selection" replace />;
    }
  }

  // User is authenticated (at least in localStorage)
  // Allow access even if context isn't fully initialized yet
  return <>{children}</>;
};

export default ProtectedRoute; 